<template>
  <div class="action-plan-signaling-form">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <p class="lead">{{ !printing ? 'Definir' : ''}} Detalhes do Serviço de Sinalização</p>
          <div v-if="!printing" class="d-flex">
            <router-link
              to="/action-plan/form"
              class="btn btn-success"
            >
              <font-awesome-icon :icon="['fas', 'arrow-left']"></font-awesome-icon>
              Voltar ao Plano de Ação
            </router-link>
            <div class="save-button ml-3">
              <button @click="save()" class="btn btn-primary">Definir</button>
            </div>
          </div>
        </div>

        <div class="col-12 d-flex justify-content-center">
          <div class="mt-4 w-50">
            <div class="col-12 col-md-12 break-after">
              <div class="form-group">
                <custom-image-uploader
                  :title="'Upload de arquivo'"
                  @file-changed-event="setFile"
                  v-if="!file"
                ></custom-image-uploader>

                <div class="file-list__item" v-if="file && !printing">
                  <div class="file-title">Arquivo</div>
                  <div class="file-name mt-1"></div>
                  <div class="file-options mt-1">
                    <img :src="file" />
                    <a
                      @click="changeImage()"
                      class="file-options clickable"
                      v-if="file"
                      >Excluir</a
                    >
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label>Material desejado</label>
                <input v-model="desiredMaterial" type="text" class="form-control" />
              </div>

              <div class="form-group">
                <label>Dimensões</label>
                <input v-model="dimensions" type="text" class="form-control" />
              </div>

              <div class="form-group">
                <label>Técnica de aplicação</label>
                <input
                  v-model="applicationTechnique"
                  type="text"
                  class="form-control"
                />
              </div>

              <div class="form-group">
                <label>Observação adicional</label>
                <textarea
                  v-model="observations"
                  type="text"
                  class="form-control"
                  rows="10"
                  style="height: auto"
                ></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { useRoute } from 'vue-router'
  import useSwal from '@/modules/Swal.js'
  import CustomImageUploader from './components/CustomImageUploader'

  export default {
    setup(props) {
      const { params } = useRoute()

      const riskAnalysisDescriptionId = params.riskAnalysisDescriptionId || props.riskAnalysisDescriptionId

      const { showConfirmDeletionSwal } = useSwal()
      const { showSuccessDialog } = useSwal()

      return {
        riskAnalysisDescriptionId,
        showConfirmDeletionSwal,
        showSuccessDialog,
      }
    },
    components: {
      CustomImageUploader,
    },
    props: {
      riskAnalysisDescriptionId: {
        type: Number,
        required: false,
      },
      printing: {
        type: Boolean,
        default: false,
        required: false,
      }
    },
    data() {
      return {
        consultancy: false,

        file: '',
        desiredMaterial: '',
        dimensions: '',
        applicationTechnique: '',
        observations: '',

        loading: false,
      }
    },
    methods: {
      changeImage() {
        this.showConfirmDeletionSwal().then((response) => {
          if (response.isConfirmed) {
            this.file = ''
          }
        })
      },

      save() {
        let payload = {
          risk_analysis_description_id: this.riskAnalysisDescriptionId,
          file: this.file,
          needs_consultancy: this.consultancy,
          material: this.desiredMaterial,
          dimensions: this.dimensions,
          applicationTechnique: this.applicationTechnique,
          observations: this.observations,
        }

        let formData = new FormData()

        Object.keys(payload).forEach((field) =>
          formData.append(field, payload[field]),
        )

        this.axios
          .post(`/api/action-plan/services/signaling`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then(() => this.showSuccessDialog())
      },
      setFile(event) {
        const file = event.file

        this.file = file
      },
      load() {
        this.loading = true

        this.axios
          .get(
            `/api/action-plan/services/${this.riskAnalysisDescriptionId}/signaling`,
          )
          .then(({ data }) => {
            const service = data.signaling_services[0]

            this.file = data.server_url + service.file
            this.consultancy = data.needs_consultancy
            this.desiredMaterial = service.material
            this.dimensions = service.dimensions
            this.applicationTechnique = service.application_technique
            this.observations = service.observations
          })
          .catch((error) => {
            console.log({ error })
          })
          .finally(() => (this.loading = false))
      },
    },
    mounted() {
      this.load()
    },
  }
</script>
